<button mat-button [style.color]="field.attrs.color ?? defaultColor">
  <mat-icon>{{field.attrs.icon}}</mat-icon>
</button>
